import React from 'react'

export default (props: any) => (
  <svg {...props} width="489" height="164" viewBox="0 0 489 164" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 82.4492V82C0 36.9208 33.9029 0 82.4881 0C112.317 0 130.177 9.96315 144.867 24.4669L122.722 50.0608C110.516 38.9625 98.0911 32.1679 82.2681 32.1679C55.6004 32.1679 36.388 54.3645 36.388 81.5508V82.0082C36.388 109.194 55.1441 131.84 82.2681 131.84C100.348 131.84 111.421 124.588 123.854 113.261L146 135.687C129.729 153.13 111.649 164 81.1356 164C34.5792 164 0 127.977 0 82.4492Z"
      fill="black"
    />
    <path
      d="M171 82.4492V82C171 36.9208 205.135 0 254.053 0C284.086 0 302.069 9.96315 316.86 24.4669L294.562 50.0608C282.273 38.9625 269.763 32.1679 253.832 32.1679C226.981 32.1679 207.637 54.3645 207.637 81.5508V82.0082C207.637 109.194 226.522 131.84 253.832 131.84C272.035 131.84 283.184 124.588 295.703 113.261L318 135.687C301.617 153.13 283.414 164 252.691 164C205.808 164 171 127.977 171 82.4492Z"
      fill="black"
    />
    <path
      d="M342 82.4492V82C342 36.9208 376.135 0 425.053 0C455.086 0 473.069 9.96315 487.86 24.4669L465.562 50.0608C453.273 38.9625 440.763 32.1679 424.832 32.1679C397.981 32.1679 378.637 54.3645 378.637 81.5508V82.0082C378.637 109.194 397.522 131.84 424.832 131.84C443.035 131.84 454.184 124.588 466.703 113.261L489 135.687C472.617 153.13 454.414 164 423.691 164C376.816 164 342 127.977 342 82.4492Z"
      fill="black"
    />
  </svg>
)
